import { TabContext, TabPanel } from "@mui/lab";
import { Box } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import { useLocation } from "react-router";
import PolicyUsers from "../Icap/users";
import AdminUsers from "../AdminLogins";

type tabValue = "policyusers" | "adminusers";

interface ActiveSessionsLocationState {
    tab?: tabValue
}

export default function ActiveSessions() {
    const location = useLocation();
    const initialTab = (location.state as ActiveSessionsLocationState | null)?.tab ?? "policyusers";
    const [currentTab, setCurrentTab] = useState<tabValue>(initialTab);

    const handleTabChange = (event: React.SyntheticEvent, newValue: tabValue) => {
        setCurrentTab(newValue);
    };

    return <>
        <TabContext value={currentTab}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={currentTab} onChange={handleTabChange}>
                    <Tab label="Policy Users" value="policyusers" id="policy-users-tab" />
                    <Tab label="Administrators" value="adminusers" id="admin-users-tab" />
                </Tabs>
            </Box>
            <TabPanel value="policyusers" sx={{ width: "100%", padding: "10px 0 0 0" }}>
                <PolicyUsers />
            </TabPanel>
            <TabPanel value="adminusers" sx={{ width: "100%", padding: "10px 0 0 0" }}>
                <AdminUsers />
            </TabPanel>
        </TabContext>
    </>;
}
